module.exports = __webpack_public_path__ + "static/indoor-farm-5ce097a76cce68892d9c7ed9efb6678c.jpg";